import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AuthenticatedLayout from "./AuthenticatedLayout.jsx";
import Dashboard from "../pages/Dashboard/Dashboard.tsx";
import Users from "../pages/Users/Users.tsx";
import Places from "../pages/Places/Places.tsx";
import Tags from "../pages/Tags/Tags.tsx";
import Categories from "../pages/Categories/Categories.tsx";
import Announcements from "../pages/Announcements/Announcements.tsx";
import ActivityGroups from "../pages/ActivityGroups/ActivityGroups.tsx";
import Tickets from "../pages/Tickets/Tickets.tsx";
import Quotes from "../pages/Quotes/Quotes.tsx";
import Settings from "../pages/Settings/Settings.tsx";
import Notifications from "../pages/Notifications/Notifications.tsx";
import Login from "../pages/Login/Login.tsx";
import Home from "../pages/Home/Home.tsx";
import PublicPlaces from "../pages/PublicPlaces/PublicPlaces.tsx";
import NotFound from "../pages/NotFound/NotFound.tsx";


const Layout = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<PublicPlaces />} />
      <Route path="/home" element={<Home />} />

      {/* Admin auth */}
      <Route path="/admin/login" element={<Login />} />

      {/* Admin protected routes */}
      <Route
        path="/admin"
        element={
          <AuthenticatedLayout>
            <Navigate to="/admin/dashboard" replace />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/dashboard"
        element={
          <AuthenticatedLayout>
            <Dashboard />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/users"
        element={
          <AuthenticatedLayout>
            <Users />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/places"
        element={
          <AuthenticatedLayout>
            <Places />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/tags"
        element={
          <AuthenticatedLayout>
            <Tags />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/categories"
        element={
          <AuthenticatedLayout>
            <Categories />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/announcements"
        element={
          <AuthenticatedLayout>
            <Announcements />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/activity-groups"
        element={
          <AuthenticatedLayout>
            <ActivityGroups />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/tickets"
        element={
          <AuthenticatedLayout>
            <Tickets />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/quotes"
        element={
          <AuthenticatedLayout>
            <Quotes />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/settings"
        element={
          <AuthenticatedLayout>
            <Settings />
          </AuthenticatedLayout>
        }
      />
      <Route
        path="/admin/notifications"
        element={
          <AuthenticatedLayout>
            <Notifications />
          </AuthenticatedLayout>
        }
      />
      <Route path="/admin/*" element={<Navigate to="/admin/dashboard" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Layout;
